/**
 * Model reprezentujący link referencyjny oraz statystyki z nim związane w Programie Ambasador.
 */
export class AmbassadorLink {

  /**
   * Unikalny adres URL (link afiliacyjny/referencyjny) wygenerowany dla danego klienta.
   * To ten link klient wysyła innym potencjalnym przyszłym klientom.
   */
  public link: string;

  /**
   * Liczba poleceń (Referrals / Leads).
   * Oznacza liczbę klinik, które kliknęły w link i podjęły akcję wstępną.
   */
  public referrals: number;

  /**
   * Liczba sfinalizowanych poleceń (Closed Deals).
   * Oznacza liczbę klinik z puli `referrals`, które faktycznie podpisały umowę
   * i stały się aktywnymi, płacącymi klientami.
   * Zazwyczaj na podstawie tej wartości przyznawane są bonusy dla Ambasadora (np. zniżka na abonament).
   */
  public refferalsClosed: number;

}
